/* eslint react/prop-types: 0 */
import React, {useContext, useState} from 'react';
import {adopt} from 'react-adopt';
import {RouteContext} from '../../../shared/enhancers/router-enhancer';
import {Query} from 'react-apollo';
import {stackupBySlug, stackupTool} from '../../../data/stackups/queries';
import {buildStackupSlug} from '../utils';

const buildToolsFromSlugs = slugs =>
  slugs.map(slug => (slug === '' ? {empty: true} : {slug, loading: true}));

const mergeToolData = (slugs, ...rest) => {
  let r = buildToolsFromSlugs(slugs);
  rest.map((data, i) => {
    if (data && data.data && data.data.tool) {
      r[i] = data.data.tool;
    }
  });
  return r;
};

const withStackup = Component => restProps => {
  const {toolSlugs, signin, routeAction} = useContext(RouteContext);
  const [signupAction, setSignupAction] = useState(null);

  // This state variable was moved up here because when a new tool is added, it was changing the route
  // which caused the toolSlugs to change, which caused the ToolQueries composite component to change,
  // which caused the StackupMobile component to re-render and reset its state, causing a visual "reset"
  // of the UI back to offset of 0. Keeping the state here means it remains persistent across tool query changes.
  const [offset, setOffset] = useState(0);

  const nonEmptySlugs = toolSlugs.filter(t => t.length > 0);
  const slug = buildStackupSlug(nonEmptySlugs.map(slug => ({slug})));

  const ToolQueries = adopt(
    Object.assign(
      {},
      toolSlugs.map(slug => ({render}) => (
        <Query query={stackupTool} variables={{slug}} skip={slug === ''} errorPolicy="ignore">
          {render}
        </Query>
      ))
    )
  );

  return (
    <ToolQueries>
      {tools => (
        <Query
          query={stackupBySlug}
          variables={{slug}}
          skip={nonEmptySlugs.length < 2}
          errorPolicy="ignore"
        >
          {({data}) => (
            <Component
              {...restProps}
              slug={slug}
              stackup={data && data.stackupBySlug ? data.stackupBySlug : null}
              tools={mergeToolData(toolSlugs, ...Object.values(tools))}
              signin={signin}
              routeAction={routeAction}
              offset={offset}
              setOffset={setOffset}
              contentGroup={'Stackups'}
              signupAction={signupAction}
              setSignupAction={setSignupAction}
            />
          )}
        </Query>
      )}
    </ToolQueries>
  );
};

export default withStackup;
